import React, {useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {useHistory } from "react-router-dom";
import Alert from "@material-ui/lab/Alert";
import firebase from "../../helpers/firebase";
import QuillNoteHeading from "../UiElements/QuillNoteHeading";
import {localStore} from "../../helpers/localStorage";

import clsx from "clsx";
import {
  Button,
  TextField,
  Grid,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  textField: {
    minWidth: "300px",
    marginBottom: "28px",
    backgroundColor: "white"
  },
 
  marginBtm:{
    marginBottom:"28px"
  }
}));

const StudentHome = () => {

  const classes = useStyles();
  const [id, setId] = useState("");
  const [name, setName] = useState("");

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  async function handleSubmit(e) {
    setLoading(true)
    e.preventDefault();
    
    try{
      const db = firebase.firestore();
      await db.collection("sessions").doc(id).collection("students").doc().set({"name":name});
      localStore.setSession(id);
      setLoading(false);
      history.push("/student/write_answer");

    }
    catch(err){
      console.log(err);
      setError(err);
    }
    setLoading(false);
  }

  return (
    <>
      <div className="loginPage">
        <QuillNoteHeading subHeading="student"/>
        <div>
        {error && <Alert className={clsx(classes.marginBtm)} severity="error">{error}</Alert>}
          <Grid container style={{"justifyContent":"center"}}>
            <form noValidate autoComplete="off" onSubmit={handleSubmit}>
              <Grid item xs={12}>
                <TextField
                  id="id"
                  label="Session Id"
                  type="text"
                  value={id}
                  variant="filled"
                  onChange={(e) => setId(e.target.value)}
                  className={clsx(classes.textField)}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="name"
                  label="Name"
                  type="text"
                  value={name}
                  variant="filled"
                  onChange={(e) => setName(e.target.value)}
                  className={clsx(classes.textField)}
                  required
                />
              </Grid>

              <Button
                type="submit"
                variant="contained"
                size="large"
                className="CustomButton w100"
              >
                {loading?"Wait..":"Log In"}
              </Button>
            </form>
          </Grid>
        </div>
      </div>
    </>
  );
};

export default StudentHome;
